import type { InternalRequest } from '../client.js';
import type { WeatherPoint } from '@trackizy/types';

export interface LayersStatus {
  aircraft?: { available: boolean; premium: boolean };
  liveuamap?: { available: boolean; configured: boolean };
  weather?: { available: boolean };
}

export interface TileTokenResponse {
  token: string;
  expiresInSeconds: number;
}

export function layersEndpoints(req: InternalRequest) {
  return {
    /** GET /api/layers/status — per-org layer availability. */
    status: () => req.request<LayersStatus>('/layers/status'),

    /** GET /api/layers/weather/point — current + AQI (+forecast) bundle,
     *  server-cached on a 0.1° grid. */
    weatherPoint: (lat: number, lon: number, opts: { forecast?: boolean; lang?: string } = {}) => {
      const params = new URLSearchParams({ lat: String(lat), lon: String(lon) });
      if (opts.forecast) params.set('forecast', '1');
      if (opts.lang) params.set('lang', opts.lang);
      return req.request<WeatherPoint>(`/layers/weather/point?${params.toString()}`);
    },

    /** POST /api/layers/tile-token — short-lived scoped token carried as `?t=`
     *  on weather raster tile URLs (RN MapLibre can't send auth headers). */
    tileToken: () => req.request<TileTokenResponse>('/layers/tile-token', { method: 'POST' }),
  };
}
